__turbopack_context__.v({
  "digit": "TotalEntriesCounter-module__S9dJRW__digit",
  "digitContainer": "TotalEntriesCounter-module__S9dJRW__digitContainer",
  "labelContainer": "TotalEntriesCounter-module__S9dJRW__labelContainer",
  "ticketIcon": "TotalEntriesCounter-module__S9dJRW__ticketIcon",
  "totalEntriesCounter": "TotalEntriesCounter-module__S9dJRW__totalEntriesCounter",
});
